/* istanbul ignore file */
import React from 'react';
import { CREATE_JOURNAL_ENTRY } from 'domain/finance/journalEntry/useJournalEntryService';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import { useAuthorization } from 'framework/authorization';
import { useFieldHelper } from 'framework/ui/field';
import { LinkButton } from 'framework/ui/ui-builder';

const CopyJournalEntryButton = (props: { source?: string }) => {
  const { getCopyEntityUrl } = useJournalEntryUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return isGranted(CREATE_JOURNAL_ENTRY) ? (
    <LinkButton variant="outlined" {...props} url={getCopyEntityUrl(id)}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopyJournalEntryButton;
